import { memo } from 'react';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Card, CardContent, List, ListItem, ListItemText, Link, Typography } from '@mui/material';

// project imports
import { APP_NAME, APP_VERSION, APP_DEPLOY_YEAR, APP_PROVIDER_NAME, APP_PROVIDER_URL } from 'config';
import ProviderLogo from 'ui-component/custom/ProviderLogo';

// assets
import Copyright from '@mui/icons-material/Copyright';

// styles
const CardStyle = styled(Card)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
    marginLeft: '10px',
    marginBottom: '10px',
    overflow: 'hidden',
    position: 'fixed',
    bottom: 0,
    width: '235px',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '157px',
        height: '157px',
        background: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.primary[200],
        borderRadius: '50%',
        top: '-105px',
        right: '-96px'
    }
}));

// ==============================|| SIDEBAR - MENU CARD ||============================== //

const MenuCard = () => {
    const theme = useTheme();

    return (
        <CardStyle>
            <CardContent sx={{ p: 2 }}>
                <List sx={{ p: 0, m: 0 }}>
                    <ListItem alignItems="flex-start" disableGutters sx={{ p: 0 }}>
                        <ProviderLogo />
                        <ListItemText
                            sx={{ mt: 0 }}
                            primary={
                                <Typography
                                    variant="subtitle1"
                                    sx={{ color: theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.primary[800] }}
                                >
                                    {APP_NAME} {APP_VERSION}
                                </Typography>
                            }
                            secondary={
                                <Typography variant="caption" component={Link} href={APP_PROVIDER_URL} target="_blank" underline="hover">
                                    <Copyright fontSize="inherit" /> {APP_DEPLOY_YEAR}, {APP_PROVIDER_NAME}
                                </Typography>
                            }
                        />
                    </ListItem>
                </List>
            </CardContent>
        </CardStyle>
    );
};

export default memo(MenuCard);
